import { render } from "./Index.vue?vue&type=template&id=4f09a637&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__